import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withKeys as _withKeys, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "editable-text" }
const _hoisted_2 = {
  key: 0,
  class: "placeholder"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 1,
  class: "write-view"
}
const _hoisted_5 = ["data-placeholder"]

import { ref, watch, nextTick } from 'vue';
import HtmlFormatter from '@/shared/services/htmlFormatter';


export default /*@__PURE__*/_defineComponent({
  __name: 'EditableText',
  props: {
  value: {
    type: String,
    default: '',
  },
  placeholder: {
    type: String,
    default: '',
  },
  multiline: {
    type: Boolean,
    default: false,
  },
  allowEmpty: {
    type: Boolean,
    default: false,
  },
  maxWidth: {
    type: String,
  },
  minWidth: {
    type: String,
  },
  maxChars: {
    type: Number,
    default: 100,
  },
},
  emits: ["text-updated"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const textfield = ref<any>(null);

const text = ref('');
const isEditing = ref(false);

watch(
  () => props.value,
  (value: string) => (text.value = value),
  { immediate: true },
);

function hasText() {
  return text.value && text.value.length > 0;
}

function getPlaceholder() {
  return props.placeholder ? props.placeholder : '&nbsp;';
}

function startEditing() {
  isEditing.value = true;
  nextTick(() => {
    let el = textfield.value;
    if (props.multiline) {
      el = textfield.value.$el;
    }
    HtmlFormatter.setCaretAtTheEndOfContentEditable(el);
  });
}

function finishEditing() {
  isEditing.value = false;
  const previousValue = props.value;
  if (!props.allowEmpty && textEmpty()) {
    text.value = props.value;
    emit('text-updated', text.value, previousValue);
  } else {
    emit('text-updated', text.value, previousValue);
  }
}

function onInput(e: any) {
  const userInput = e.target.innerText;
  if (userInput.length < props.maxChars) {
    text.value = userInput;
  }
}

function textEmpty(): boolean {
  return typeof text.value === 'undefined' || !text.value || 0 === text.value.length;
}

return (_ctx: any,_cache: any) => {
  const _component_textarea_autosize = _resolveComponent("textarea-autosize")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isEditing.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["read-view", { 'single-line': !__props.multiline }]),
          onClick: startEditing,
          style: _normalizeStyle({ minWidth: __props.minWidth, maxWidth: __props.maxWidth })
        }, [
          (!hasText())
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.placeholder || ' '), 1))
            : _createCommentVNode("", true),
          (hasText())
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(text.value), 1))
            : _createCommentVNode("", true)
        ], 6))
      : _createCommentVNode("", true),
    (isEditing.value)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          (__props.multiline)
            ? (_openBlock(), _createBlock(_component_textarea_autosize, {
                key: 0,
                ref_key: "textfield",
                ref: textfield,
                modelValue: text.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
                onKeydown: _withKeys(finishEditing, ["enter","native"]),
                rows: "1",
                placeholder: __props.placeholder
              }, null, 8, ["modelValue", "placeholder"]))
            : _createCommentVNode("", true),
          (!__props.multiline)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "edit-single-line",
                ref_key: "textfield",
                ref: textfield,
                style: _normalizeStyle({ minWidth: __props.minWidth, maxWidth: __props.maxWidth }),
                onKeydown: _withKeys(finishEditing, ["enter"]),
                onInput: onInput,
                contenteditable: "true",
                "data-placeholder": getPlaceholder()
              }, _toDisplayString(__props.value), 45, _hoisted_5))
            : _createCommentVNode("", true)
        ])), [
          [_directive_click_away, finishEditing]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})